var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9818 18V6H13.0182V18H10.9818ZM6 13.0182V10.9818H18V13.0182H6Z",
    fill: "#073763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOutline);
export default __webpack_public_path__ + "static/media/AddOutline.b911fbca4f70d1d49a430d2fdb63a342.svg";
export { ForwardRef as ReactComponent };